var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "body",
      {
        staticClass:
          "home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container",
        staticStyle: { "overflow-y": "unset" },
        attrs: { "data-anchor": "pagetop" }
      },
      [
        _c("navbar", {
          attrs: {
            follow: "st-Header",
            imgSrc: "../../../../static/img/logo/logo-black.png"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "st-FixedPoint" }),
        _vm._v(" "),
        _c("div", { staticClass: "st-MainContainer" }, [
          _c("main", { staticClass: "st-MainContents mt-6" }, [
            _c("div", { staticClass: "st-Grid" }, [
              _c("div", { staticClass: "st-Grid_Inner" }, [
                _c("article", { staticClass: "news-Detail pt-0" }, [
                  _c(
                    "header",
                    {
                      staticClass:
                        "news-Detail_Title common-text-appear news-detail-appear-1",
                      attrs: { "data-appear": "true" }
                    },
                    [
                      _c("div", { staticClass: "sw-Eyebrow" }, [
                        _c(
                          "p",
                          {
                            staticClass: "sw-Eyebrow_Lavel",
                            attrs: { id: "lavel", "data-lavel": "product" }
                          },
                          [
                            _c(
                              "font",
                              [
                                _c("font", { attrs: { id: "lavel-name" } }, [
                                  _vm._v("会社情報")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "sw-Eyebrow_Date" },
                          [
                            _c(
                              "font",
                              [
                                _c("font", { attrs: { id: "news-date" } }, [
                                  _vm._v("2020.10.30")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "h1",
                        [
                          _c(
                            "font",
                            [
                              _c("font", { attrs: { id: "news-title" } }, [
                                _vm._v("标题内容标题内容标题内容")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "news-Detail_Body" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "common-text-appear news-detail-appear-3",
                        attrs: { "data-appear": "true" }
                      },
                      [
                        _c("font"),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "font",
                          [_c("font", { attrs: { id: "news-content" } })],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "section",
              {
                staticClass: "top-card pt-0 pb-5",
                staticStyle: { "background-color": "#fff" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "st-Grid_Inner news-detail-appear-4 p-0 pl-md-5",
                    attrs: { "data-appear": "true" }
                  },
                  [
                    _c(
                      "h2",
                      {
                        staticClass: "sw-Section_Header news-detail-appear-5",
                        attrs: { "data-appear": "true" }
                      },
                      [
                        _c("span", { staticClass: "sw-Section_Header-en" }, [
                          _c(
                            "b",
                            [
                              _c(
                                "font",
                                [_c("font", [_vm._v("OTHER NEWS")])],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "sw-Section_Header-ja" }, [
                          _c(
                            "b",
                            [_c("font", [_c("font", [_vm._v("お知らせ")])], 1)],
                            1
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "st-News_Slide swiper-container-news-detail swiper-container-initialized swiper-container-horizontal news-detail-appear-6",
                        attrs: { "data-appear": "true" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "swiper-wrapper" },
                          _vm._l(_vm.newsList, function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "swiper-slide swiper-slide-news"
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.goNewsDetail(item.newsId)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "st-News_Slide-image" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "st-News_Slide-image-inner"
                                          },
                                          [
                                            _c("div", {
                                              style: {
                                                "background-image":
                                                  "url(../../../static/img/news/" +
                                                  item.imgSrc +
                                                  ")"
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "sw-Eyebrow" }, [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "sw-Eyebrow_Lavel",
                                          attrs: { "data-lavel": item.lavel }
                                        },
                                        [
                                          _c(
                                            "font",
                                            [
                                              _c("font", [
                                                _vm._v(
                                                  _vm._s(
                                                    item.lavel === "company"
                                                      ? "COMPANY"
                                                      : "PRODUCT"
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { staticClass: "sw-Eyebrow_Category" },
                                        [_c("font", [_c("font")], 1)],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { staticClass: "sw-Eyebrow_Date" },
                                        [
                                          _c(
                                            "font",
                                            [
                                              _c("font", [
                                                _vm._v(_vm._s(item.date))
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "st-News_Slide-title" },
                                      [
                                        _c(
                                          "font",
                                          [
                                            _c("font", [
                                              _vm._v(_vm._s(item.title))
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm._m(4),
                        _vm._v(" "),
                        _vm._m(5),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "swiper-notification",
                          attrs: {
                            "aria-live": "assertive",
                            "aria-atomic": "true"
                          }
                        })
                      ]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "st-Breadcrumbs" }, [
              _c("ul", { staticClass: "st-BreadcrumbsList pl-0" }, [
                _c(
                  "li",
                  { staticClass: "st-BreadcrumbsList_Item" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "st-BreadcrumbsList_Item-link",
                        attrs: { to: "/" }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { itemprop: "name" } },
                          [_c("font", [_c("font", [_vm._v("ホーム")])], 1)],
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "st-BreadcrumbsList_Item" }, [
                  _c(
                    "p",
                    {
                      staticStyle: { "margin-bottom": "0rem" },
                      attrs: { itemprop: "item", "aria-current": "page" }
                    },
                    [
                      _c(
                        "span",
                        { attrs: { itemprop: "name" } },
                        [_c("font", [_c("font", [_vm._v("お知らせ")])], 1)],
                        1
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("copyright")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "common-image-appear news-detail-appear-2",
        attrs: { "data-appear": "true" }
      },
      [
        _c("picture", [
          _c("img", { attrs: { id: "news-imgSrc", width: "100%" } })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "common-image-appear news-detail-appear-22 pt-4 d-none",
        attrs: { "data-appear": "true" }
      },
      [
        _c("picture", [
          _c("img", { attrs: { id: "news-imgSrc2", width: "100%" } })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "common-image-appear news-detail-appear-23 pt-4 d-none",
        attrs: { "data-appear": "true" }
      },
      [
        _c("picture", [
          _c("img", { attrs: { id: "news-imgSrc3", width: "100%" } })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "common-image-appear news-detail-appear-24 pt-4 d-none",
        attrs: { "data-appear": "true" }
      },
      [
        _c("picture", [
          _c("div", { staticClass: "row col-12 m-0" }, [
            _c("div", { staticClass: "col-6 pl-0" }, [
              _c("img", { attrs: { id: "news-imgSrc1", width: "100%" } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 pr-0" }, [
              _c("img", { attrs: { id: "news-imgSrc4", width: "100%" } })
            ])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "swiper-button-next" }, [
      _c("i", {
        staticClass: "icf el-icon-arrow-right",
        staticStyle: { "font-size": "25px", bottom: "15px" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "swiper-button-prev swiper-button-disabled" },
      [
        _c("i", {
          staticClass: "icf el-icon-arrow-left",
          staticStyle: { "font-size": "25px", bottom: "15px" }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-525c990a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-525c990a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/news/news-detail.vue
// module id = null
// module chunks = 